
export const columns = ()=> [
    {
        name: "S.No",
        label: "S.No",
        options: {
            filter: true,
            sort: true,
            customBodyRender: (value, tableMeta) => tableMeta.rowIndex + 1
        }
    },
    {
        name: "Pattern",
        label: "Pattern",
        options: {
            filter: true,
            sort: true,
        }
    },
    {
        name: "Trend before pattern",
        label: "Trend before pattern",
        options: {
            filter: true,
            sort: true,
        }
    },
    {
        name: "Previous trend price",
        label: "Previous trend price",
        options: {
            filter: true,
            sort: true,
        }
    },
    {
        name: "Start Time",
        label: "Start Time",
        options: {
            filter: true,
            sort: true,
        }
    },
    {
        name: "Start Price",
        label: "Start Price",
        options: {
            filter: true,
            sort: true,
        }
    },
    {
        name: "End Time",
        label: "End Time",
        options: {
            filter: true,
            sort: true,
        }
    },
    {
        name: "End Price",
        label: "End Price",
        options: {
            filter: true,
            sort: true,
        }
    },
    {
        name: "After trend price",
        label: "After trend price",
        options: {
            filter: true,
            sort: true,
        }
    },
    {
        name: "Trend after pattern",
        label: "Trend after pattern",
        options: {
            filter: true,
            sort: true,
        }
    },
];
export const columns1 =()=> [
    {
        name: "S.No",
        label: "S.No",
        options: {
            filter: true,
            sort: true,
            customBodyRender: (value, tableMeta) => tableMeta.rowIndex + 1
        }
    },
    {
        name: "_id",
        label: "Time",
        options: {
            filter: true,
            sort: true,
        }
    },
    {
        name: "open",
        label: "open",
        options: {
            filter: true,
            sort: true,
        }
    },
    {
        name: "close",
        label: "close",
        options: {
            filter: true,
            sort: true,
        }
    },
    {
        name: "high",
        label: "high",
        options: {
            filter: true,
            sort: true,
        }
    },
    {
        name: "low",
        label: "low",
        options: {
            filter: true,
            sort: true,
        }
    },
    
     {
        name: "Pattern",
        label: "Pattern",
        options: {
            filter: true,
            sort: true,
        }
    },
];



// Last Pattern Column
export const columns2 = () => [
    {
        name: "S.No",
        label: "S.No",
        options: {
            filter: true,
            sort: true,
            customBodyRender: (value, tableMeta, updateValue) => {
                const rowIndex = tableMeta.rowIndex;
                return rowIndex + 1;
            }
        },
    },
    {
        name: "Date",
        label: "Date",
        options: {
            filter: true,
            sort: true,
        }
    },
    {
        name: "Pattern",
        label: "Pattern",
        options: {
            filter: true,
            sort: true,
        }
    },
    {
        name: "Symbol",
        label: "Symbol",
        options: {
            filter: true,
            sort: true,
        }
    },
    
];

export const columns3 = ()=> [
    {
        name: "S.No",
        label: "S.No",
        options: {
            filter: true,
            sort: true,
            customBodyRender: (value, tableMeta, updateValue) => {
                const rowIndex = tableMeta.rowIndex;
                return rowIndex + 1;
            }
        },
    },
    {
        name: "pattern",
        label: "pattern",
        options: {
            filter: true,
            sort: true,
        }
    },
    {
        name: "start_pattern",
        label: "start pattern",
        options: {
            filter: true,
            sort: true,
        }
    },
    {
        name: "End_pattern",
        label: "End pattern",
        options: {
            filter: true,
            sort: true,
        }
    },
    {
        name: "Symbol",
        label: "Symbol",
        options: {
            filter: true,
            sort: true,
        }
    },
];